import { useMemo } from "react";
import { Box, Stack } from "@mui/material";
import FrostedCard from "./FrostedCard";
import KayttoIkaToggle from "./KayttoIkaToggle";
import SpecRow from "./SpecRow";
import WizardEyebrow from "./WizardEyebrow";
import { rasitusluokkaPresets } from "src/utils/quote/rasitusluokat";
import { KAYTTO_IKA_ID_100V } from "src/utils/quote/quoteConstants";
import { useT } from "src/i18n";

export default function SpecGuideResult({ terminal, kayttoIkaId, onKayttoIkaChange }) {
    const t = useT();
    const coverMm = terminal.cover
        ? (kayttoIkaId === KAYTTO_IKA_ID_100V ? terminal.cover.c100y : terminal.cover.c50y)
        : null;
    const coverDisplay = coverMm == null ? t("wizard.specGuideResult.coverManual") : `${coverMm} mm`;

    // Look up the matching preset for the richer meaning + example strings.
    // Falls back to terminal.description when the canonical preset isn't in the
    // PRESETS list (e.g. legacy/edge values), so the result panel never goes blank.
    const presets = useMemo(() => rasitusluokkaPresets(t), [t]);
    const preset = presets.find((p) => p.value === terminal.result);
    const meaning = preset?.meaning;
    const example = preset?.example || terminal.description;

    return (
        <FrostedCard tone="success" sx={{ p: 2.5 }}>
            <WizardEyebrow color="text.secondary" sx={{ mb: 1.25 }}>
                {t("wizard.specGuideResult.recommendedTitle")}
            </WizardEyebrow>
            <Stack spacing={1.25}>
                <SpecRow label={t("wizard.shared.rasitusluokkaLabel")} value={terminal.result} />
                {meaning && (
                    <Box sx={{ fontSize: 12, color: "text.secondary", lineHeight: 1.55, mt: -0.25 }}>
                        {meaning}
                    </Box>
                )}
                <SpecRow label={t("wizard.specGuideResult.minLujuusLabel")} value={terminal.lujuusluokkaMin} />
                {example && (
                    <Box sx={{ fontSize: 12, color: "text.secondary", fontStyle: "italic", lineHeight: 1.55 }}>
                        {t("wizard.shared.example")} {example}
                    </Box>
                )}
                <KayttoIkaToggle
                    value={kayttoIkaId}
                    onChange={onKayttoIkaChange}
                    sx={{ pt: 0.5 }}
                />
                <SpecRow label={t("wizard.specGuideResult.coverLabel")} value={coverDisplay} />
            </Stack>
            <Box sx={{ fontSize: 12, color: "text.secondary", fontStyle: "italic", lineHeight: 1.55, mt: 1.5 }}>
                {t("wizard.quoteConstants.betoniLaatuDisclaimer")}
            </Box>
        </FrostedCard>
    );
}
